export default {
     "NODE0": {
          "locationKey": "NORTH_CASTLE",
          "x": 23,
          "y": 52,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [
               "NODE1",
               "NODE2",
               "NODE3",
               "NODE7",
               "NODE8",
               "NODE9",
               "NODE10"
          ],
          "type": "ANY"
     },
     "NODE1": {
          "locationKey": "MAGIC_CAVE",
          "x": 16,
          "y": 60,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "suggestion": "link",
          "connections": [],
          "type": "CAVE"
     },
     "NODE2": {
          "locationKey": "TROPHY_CAVE",
          "x": 29,
          "y": 32,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "suggestion": "link",
          "connections": [],
          "type": "CAVE"
     },
     "NODE3": {
          "locationKey": "PARAPA_CAVE_S",
          "x": 55,
          "y": 46,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "suggestion": "link",
          "connections": [],
          "type": "CAVE"
     },
     "NODE4": {
          "locationKey": "PARAPA_CAVE_N",
          "x": 48,
          "y": 41,
          "isolationGroup": 1,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "suggestion": "link!",
          "connections": [
               "NODE32",
               "NODE5"
          ],
          "type": "CAVE"
     },
     "NODE5": {
          "locationKey": "BUBBLE_CLIFF",
          "x": 61,
          "y": 57,
          "isolationGroup": 1,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "suggestion": "passthrough!",
          "connections": [
               "NODE6"
          ],
          "type": "ANY"
     },
     "NODE6": {
          "locationKey": "HEART_CLIFF",
          "x": 62,
          "y": 64,
          "isolationGroup": 1,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE7": {
          "locationKey": "JUMP_CAVE_N",
          "x": 1,
          "y": 58,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "suggestion": "link",
          "connections": [],
          "type": "CAVE"
     },
     "NODE8": {
          "locationKey": "SHIELD_TOWN",
          "x": 46,
          "y": 54,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "suggestion": "town?",
          "connections": [
               "NODE33"
          ],
          "connectionRequirements": {
               "NODE33": [
                    "HAMMER"
               ]
          },
          "type": "ANY"
     },
     "NODE9": {
          "locationKey": "JUMP_TOWN",
          "x": 2,
          "y": 36,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "suggestion": "town?",
          "connections": [],
          "type": "ANY"
     },
     "NODE10": {
          "locationKey": "FOREST_50P",
          "x": 37,
          "y": 42,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "FOREST"
     },
     "NODE11": {
          "locationKey": "FOREST_100P",
          "x": 20,
          "y": 86,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "FOREST"
     },
     "NODE12": {
          "locationKey": "JUMP_CAVE_S",
          "x": 3,
          "y": 62,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [
               "NODE13",
               "NODE16",
               "NODE15",
               "NODE14",
               "NODE40",
               "NODE41",
               "NODE42",
               "NODE43",
               "NODE44",
               "NODE17",
               "NODE18",
               "NODE33",
               "NODE19",
               "NODE20",
               "NODE24",
               "NODE27",
               "NODE38",
               "NODE39"
          ],
          "connectionRequirements": {
               "NODE16": [
                    "HAMMER"
               ],
               "NODE17": [
                    "HAMMER"
               ],
               "NODE24": [
                    "HAMMER"
               ]
          },
          "type": "CAVE"
     },
     "NODE13": {
          "locationKey": "MEDICINE_CAVE_FAIRY",
          "x": 7,
          "y": 64,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "CAVE"
     },
     "NODE14": {
          "locationKey": "BAGUS_CABIN",
          "x": 21,
          "y": 76,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "FOREST"
     },
     "NODE15": {
          "locationKey": "EX_LIFE_SWAMP_1",
          "x": 8,
          "y": 71,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "SWAMP"
     },
     "NODE16": {
          "locationKey": "MEDICINE_CAVE",
          "x": 9,
          "y": 69,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "suggestion": "link",
          "connections": [],
          "type": "CAVE"
     },
     "NODE17": {
          "locationKey": "HEART_CAVE",
          "x": 54,
          "y": 62,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "suggestion": "link",
          "connections": [],
          "type": "CAVE"
     },
     "NODE18": {
          "locationKey": "CAVE_200P",
          "x": 38,
          "y": 62,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "CAVE"
     },
     "NODE19": {
          "locationKey": "P2_RED_JAR",
          "x": 37,
          "y": 68,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE20": {
          "locationKey": "RED_JAR_SWAMP",
          "x": 17,
          "y": 67,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "SWAMP"
     },
     "NODE21": {
          "locationKey": "EX_LIFE_BEACH",
          "x": 38,
          "y": 102,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "DESERT"
     },
     "NODE22": {
          "locationKey": "RED_JAR_CEM",
          "x": 48,
          "y": 92,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "CEMETARY"
     },
     "NODE23": {
          "locationKey": "RAFT_DOCK_W",
          "x": 61,
          "y": 77,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "WATER"
     },
     "NODE24": {
          "locationKey": "FAIRY_TOWN",
          "x": 60,
          "y": 75,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [
               "NODE23",
               "NODE35",
               "NODE22",
               "NODE25",
               "NODE21",
               "NODE30"
          ],
          "type": "ANY"
     },
     "NODE25": {
          "locationKey": "FAIRY_CAVE_HOLE",
          "x": 50,
          "y": 96,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "suggestion": "link!",
          "connections": [],
          "type": "CEMETARY"
     },
     "NODE26": {
          "locationKey": "FAIRY_CAVE",
          "x": 59,
          "y": 102,
          "isolationGroup": 4,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [
               "NODE34"
          ],
          "type": "CAVE"
     },
     "NODE27": {
          "locationKey": "LIFE_TOWN_BRIDGE_NS",
          "x": 16,
          "y": 82,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [
               "NODE28",
               "NODE38",
               "NODE11"
          ],
          "type": "WATER"
     },
     "NODE28": {
          "locationKey": "LIFE_TOWN_N",
          "x": 8,
          "y": 89,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE29": {
          "locationKey": "LIFE_TOWN_S",
          "x": 8,
          "y": 91,
          "isolationGroup": 5,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [
               "NODE37"
          ],
          "type": "ANY"
     },
     "NODE30": {
          "locationKey": "DM_BRIDGE_EXIT_E",
          "x": 34,
          "y": 97,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "WATER"
     },
     "NODE31": {
          "locationKey": "DM_BRIDGE_EXIT_W",
          "x": 26,
          "y": 97,
          "isolationGroup": 6,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [
               "NODE36"
          ],
          "type": "WATER"
     },
     "NODE32": {
          "locationKey": "P1",
          "x": 62,
          "y": 32,
          "isolationGroup": 1,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE33": {
          "locationKey": "P2",
          "x": 11,
          "y": 64,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE34": {
          "locationKey": "P3",
          "x": 57,
          "y": 98,
          "isolationGroup": 4,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE35": {
          "locationKey": "KINGS_TOMB",
          "x": 50,
          "y": 88,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "CEMETARY"
     },
     "NODE36": {
          "locationKey": "DM_EXIT",
          "x": 21,
          "y": 96,
          "isolationGroup": 6,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "suggestion": "link",
          "connections": [],
          "type": "ANY"
     },
     "NODE37": {
          "locationKey": "DM_ENTRANCE",
          "x": 10,
          "y": 95,
          "isolationGroup": 5,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "suggestion": "link",
          "connections": [],
          "type": "ANY"
     },
     "NODE38": {
          "locationKey": "LIFE_TOWN_BRIDGE_EW",
          "x": 26,
          "y": 87,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "WATER"
     },
     "NODE39": {
          "locationKey": "LIFE_TOWN_FAIRY",
          "x": 33,
          "y": 87,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "FOREST"
     },
     "NODE40": {
          "locationKey": "LOST_WOODS_1",
          "x": 21,
          "y": 77,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "FOREST"
     },
     "NODE41": {
          "locationKey": "LOST_WOODS_2",
          "x": 20,
          "y": 76,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "FOREST"
     },
     "NODE42": {
          "locationKey": "LOST_WOODS_3",
          "x": 17,
          "y": 77,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "FOREST"
     },
     "NODE43": {
          "locationKey": "LOST_WOODS_4",
          "x": 19,
          "y": 78,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "FOREST"
     },
     "NODE44": {
          "locationKey": "LOST_WOODS_5",
          "x": 23,
          "y": 77,
          "isolationGroup": 2,
          "continent": 0,
          "continentName": "WEST HYRULE",
          "connections": [],
          "type": "FOREST"
     },
     "NODE45": {
          "locationKey": "RAFT_DOCK_E",
          "x": 7,
          "y": 52,
          "isolationGroup": 7,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [
               "NODE75",
               "NODE76",
               "NODE130",
               "NODE73",
               "NODE46",
               "NODE74",
               "NODE77",
               "NODE78",
               "NODE79",
               "NODE48",
               "NODE81"
          ],
          "connectionRequirements": {
               "NODE48": [
                    "RECORDER"
               ],
               "NODE79": [
                    "BOOTS"
               ],
               "NODE77": [
                    "BOOTS"
               ],
               "NODE81": [
                    "BOOTS"
               ],
               "NODE78": [
                    "BOOTS | HAMMER"
               ]
          },
          "type": "WATER"
     },
     "NODE46": {
          "locationKey": "FIRE_TOWN_CAVE_EXIT",
          "x": 24,
          "y": 52,
          "isolationGroup": 7,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "link",
          "connections": [],
          "type": "CAVE"
     },
     "NODE47": {
          "locationKey": "FIRE_TOWN_CAVE_ENTRANCE",
          "x": 27,
          "y": 48,
          "isolationGroup": 7,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "link!",
          "connections": [
               "NODE81",
               "NODE69",
               "NODE72"
          ],
          "type": "CAVE"
     },
     "NODE48": {
          "locationKey": "WILSON_FENCE_1",
          "x": 21,
          "y": 76,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "passthrough!",
          "connections": [
               "NODE49"
          ],
          "type": "ANY"
     },
     "NODE49": {
          "locationKey": "WILSON_FENCE_2",
          "x": 17,
          "y": 81,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "passthrough!",
          "connections": [
               "NODE50"
          ],
          "type": "ANY"
     },
     "NODE50": {
          "locationKey": "WILSON_FENCE_3",
          "x": 19,
          "y": 84,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "passthrough!",
          "connections": [
               "NODE59",
               "NODE131",
               "NODE132",
               "NODE56",
               "NODE57",
               "NODE53",
               "NODE52",
               "NODE51",
               "NODE80"
          ],
          "type": "ANY"
     },
     "NODE51": {
          "locationKey": "P6_HEART",
          "x": 57,
          "y": 99,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE52": {
          "locationKey": "P6_500P_BAG",
          "x": 54,
          "y": 91,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE53": {
          "locationKey": "SPELL_TOWN_CAVE_ENTRANCE",
          "x": 49,
          "y": 78,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "link!",
          "connections": [],
          "type": "CAVE"
     },
     "NODE54": {
          "locationKey": "SPELL_TOWN_CAVE_EXIT",
          "x": 57,
          "y": 78,
          "isolationGroup": 10,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "link",
          "connections": [
               "NODE55"
          ],
          "type": "CAVE"
     },
     "NODE55": {
          "locationKey": "SPELL_TOWN",
          "x": 61,
          "y": 81,
          "isolationGroup": 10,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE56": {
          "locationKey": "THUNDER_TOWN_N_BRIDGE",
          "x": 35,
          "y": 93,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [
               "NODE80"
          ],
          "type": "WATER"
     },
     "NODE57": {
          "locationKey": "THUNDER_TOWN_E_BRIDGE",
          "x": 37,
          "y": 100,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [
               "NODE58"
          ],
          "type": "WATER"
     },
     "NODE58": {
          "locationKey": "THUNDER_TOWN",
          "x": 34,
          "y": 99,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE59": {
          "locationKey": "WILSON_FENCE_4",
          "x": 24,
          "y": 96,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "passthrough!",
          "connections": [
               "NODE67",
               "NODE60"
          ],
          "type": "ANY"
     },
     "NODE60": {
          "locationKey": "DEATH_VALLEY_BATTLE_1",
          "x": 8,
          "y": 99,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "passthrough!",
          "connections": [
               "NODE68",
               "NODE61"
          ],
          "type": "LAVA"
     },
     "NODE61": {
          "locationKey": "DEATH_VALLEY_BATTLE_2",
          "x": 8,
          "y": 86,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "passthrough!",
          "connections": [
               "NODE62"
          ],
          "type": "LAVA"
     },
     "NODE62": {
          "locationKey": "DEATH_VALLEY_CAVE_2_ENTRANCE",
          "x": 10,
          "y": 77,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "link!",
          "connections": [],
          "type": "CAVE"
     },
     "NODE63": {
          "locationKey": "DEATH_VALLEY_CAVE_2_EXIT",
          "x": 6,
          "y": 77,
          "isolationGroup": 11,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "link!",
          "connections": [
               "NODE64"
          ],
          "type": "CAVE"
     },
     "NODE64": {
          "locationKey": "DEATH_VALLEY_BATTLE_3",
          "x": 3,
          "y": 83,
          "isolationGroup": 11,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "passthrough!",
          "connections": [
               "NODE65"
          ],
          "type": "LAVA"
     },
     "NODE65": {
          "locationKey": "DEATH_VALLEY_CAVE_1_EXIT",
          "x": 2,
          "y": 75,
          "isolationGroup": 11,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "link!",
          "connections": [],
          "type": "CAVE"
     },
     "NODE66": {
          "locationKey": "DEATH_VALLEY_CAVE_1_ENTRANCE",
          "x": 4,
          "y": 75,
          "isolationGroup": 12,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "link!",
          "connections": [
               "NODE129"
          ],
          "type": "CAVE"
     },
     "NODE67": {
          "locationKey": "DEATH_VALLEY_RED_JAR",
          "x": 27,
          "y": 99,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "LAVA"
     },
     "NODE68": {
          "locationKey": "DEATH_VALLEY_500P_BAG",
          "x": 4,
          "y": 91,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "LAVA"
     },
     "NODE69": {
          "locationKey": "REFLECT_TOWN_CLIFF_2",
          "x": 10,
          "y": 38,
          "isolationGroup": 7,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "passthrough!",
          "connections": [
               "NODE70"
          ],
          "type": "ANY"
     },
     "NODE70": {
          "locationKey": "REFLECT_TOWN_CLIFF_1",
          "x": 9,
          "y": 36,
          "isolationGroup": 7,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "suggestion": "passthrough!",
          "connections": [
               "NODE71"
          ],
          "type": "ANY"
     },
     "NODE71": {
          "locationKey": "REFLECT_TOWN",
          "x": 3,
          "y": 33,
          "isolationGroup": 7,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE72": {
          "locationKey": "MAZE_ISLAND_BRIDGE",
          "x": 52,
          "y": 40,
          "isolationGroup": 7,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "WATER"
     },
     "NODE73": {
          "locationKey": "FIRE_TOWN_CAVE_500P_BAG",
          "x": 25,
          "y": 71,
          "isolationGroup": 7,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "CAVE"
     },
     "NODE74": {
          "locationKey": "FIRE_TOWN_RED_JAR",
          "x": 34,
          "y": 56,
          "isolationGroup": 7,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE75": {
          "locationKey": "FIRE_TOWN_FOREST_500P_BAG",
          "x": 10,
          "y": 58,
          "isolationGroup": 7,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "FOREST"
     },
     "NODE76": {
          "locationKey": "FIRE_TOWN_FAIRY",
          "x": 13,
          "y": 68,
          "isolationGroup": 7,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "FOREST"
     },
     "NODE77": {
          "locationKey": "P5_HEART",
          "x": 63,
          "y": 56,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "WATER"
     },
     "NODE78": {
          "locationKey": "P5_500P_BAG",
          "x": 53,
          "y": 64,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "DESERT"
     },
     "NODE79": {
          "locationKey": "P5",
          "x": 62,
          "y": 60,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE80": {
          "locationKey": "P6",
          "x": 45,
          "y": 102,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE81": {
          "locationKey": "DAZZLE_LIFE",
          "x": 48,
          "y": 44,
          "isolationGroup": 7,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "DESERT"
     },
     "NODE82": {
          "locationKey": "CAVE_A",
          "x": 7,
          "y": 37,
          "isolationGroup": 13,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [
               "NODE83",
               "NODE97"
          ],
          "type": "CAVE"
     },
     "NODE83": {
          "locationKey": "CAVE_B_E",
          "x": 4,
          "y": 41,
          "isolationGroup": 13,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE84": {
          "locationKey": "CAVE_B_W",
          "x": 0,
          "y": 42,
          "isolationGroup": 14,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [
               "NODE85"
          ],
          "type": "CAVE"
     },
     "NODE85": {
          "locationKey": "CAVE_D_E",
          "x": 3,
          "y": 45,
          "isolationGroup": 14,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE86": {
          "locationKey": "CAVE_D_W",
          "x": 7,
          "y": 45,
          "isolationGroup": 15,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [
               "NODE87",
               "NODE133"
          ],
          "type": "CAVE"
     },
     "NODE87": {
          "locationKey": "CAVE_F_W",
          "x": 5,
          "y": 47,
          "isolationGroup": 15,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE88": {
          "locationKey": "CAVE_F_E",
          "x": 3,
          "y": 48,
          "isolationGroup": 16,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [
               "NODE89"
          ],
          "type": "CAVE"
     },
     "NODE89": {
          "locationKey": "CAVE_I_S",
          "x": 4,
          "y": 51,
          "isolationGroup": 16,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE90": {
          "locationKey": "CAVE_I_N",
          "x": 5,
          "y": 54,
          "isolationGroup": 17,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [
               "NODE91",
               "NODE93",
               "NODE94"
          ],
          "type": "CAVE"
     },
     "NODE91": {
          "locationKey": "CAVE_M_W",
          "x": 7,
          "y": 57,
          "isolationGroup": 17,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE92": {
          "locationKey": "CAVE_M_E",
          "x": 3,
          "y": 59,
          "isolationGroup": 33,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE93": {
          "locationKey": "ELEVATOR_CAVE_G_E_BL",
          "x": 11,
          "y": 54,
          "isolationGroup": 17,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE94": {
          "locationKey": "ELEVATOR_CAVE_H_E_TL",
          "x": 8,
          "y": 52,
          "isolationGroup": 17,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE95": {
          "locationKey": "ELEVATOR_CAVE_G_W_BR",
          "x": 14,
          "y": 54,
          "isolationGroup": 32,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE96": {
          "locationKey": "ELEVATOR_CAVE_G_W_TR",
          "x": 11,
          "y": 48,
          "isolationGroup": 18,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [
               "NODE104",
               "NODE134"
          ],
          "type": "CAVE"
     },
     "NODE97": {
          "locationKey": "CAVE_C_E",
          "x": 9,
          "y": 40,
          "isolationGroup": 13,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE98": {
          "locationKey": "CAVE_C_W",
          "x": 11,
          "y": 42,
          "isolationGroup": 19,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [
               "NODE99"
          ],
          "type": "CAVE"
     },
     "NODE99": {
          "locationKey": "CAVE_E_N",
          "x": 16,
          "y": 43,
          "isolationGroup": 19,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE100": {
          "locationKey": "CAVE_E_S",
          "x": 14,
          "y": 39,
          "isolationGroup": 20,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [
               "NODE101"
          ],
          "type": "CAVE"
     },
     "NODE101": {
          "locationKey": "ELEVATOR_CAVE_H_S_BL",
          "x": 18,
          "y": 40,
          "isolationGroup": 20,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE102": {
          "locationKey": "ELEVATOR_CAVE_H_N_BR",
          "x": 18,
          "y": 44,
          "isolationGroup": 21,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [
               "NODE103",
               "NODE105"
          ],
          "type": "CAVE"
     },
     "NODE103": {
          "locationKey": "CAVE_J_W",
          "x": 16,
          "y": 48,
          "isolationGroup": 21,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE104": {
          "locationKey": "CAVE_J_E",
          "x": 14,
          "y": 47,
          "isolationGroup": 18,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE105": {
          "locationKey": "CAVE_L_S",
          "x": 20,
          "y": 48,
          "isolationGroup": 21,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE106": {
          "locationKey": "CAVE_L_N",
          "x": 20,
          "y": 50,
          "isolationGroup": 22,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [
               "NODE107"
          ],
          "type": "CAVE"
     },
     "NODE107": {
          "locationKey": "CAVE_O_S",
          "x": 22,
          "y": 52,
          "isolationGroup": 22,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE108": {
          "locationKey": "CAVE_O_N",
          "x": 20,
          "y": 54,
          "isolationGroup": 23,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [
               "NODE109"
          ],
          "type": "CAVE"
     },
     "NODE109": {
          "locationKey": "CAVE_P_W",
          "x": 18,
          "y": 57,
          "isolationGroup": 23,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE110": {
          "locationKey": "CAVE_P_E",
          "x": 15,
          "y": 58,
          "isolationGroup": 24,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [
               "NODE111"
          ],
          "type": "CAVE"
     },
     "NODE111": {
          "locationKey": "CAVE_Q_E",
          "x": 13,
          "y": 60,
          "isolationGroup": 24,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE112": {
          "locationKey": "CAVE_Q_W",
          "x": 17,
          "y": 60,
          "isolationGroup": 25,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [
               "NODE113"
          ],
          "type": "CAVE"
     },
     "NODE113": {
          "locationKey": "CAVE_R_N",
          "x": 18,
          "y": 63,
          "isolationGroup": 25,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE114": {
          "locationKey": "CAVE_R_S",
          "x": 16,
          "y": 65,
          "isolationGroup": 26,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [
               "NODE135",
               "NODE115",
               "NODE116"
          ],
          "type": "CAVE"
     },
     "NODE115": {
          "locationKey": "HAMMER_CAVE",
          "x": 10,
          "y": 64,
          "isolationGroup": 26,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE116": {
          "locationKey": "DM_MAGIC",
          "x": 8,
          "y": 64,
          "isolationGroup": 26,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "ANY"
     },
     "NODE117": {
          "locationKey": "CAVE_K",
          "x": 23,
          "y": 37,
          "isolationGroup": 28,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE118": {
          "locationKey": "EAST_HYRULE_BRIDGE",
          "x": 40,
          "y": 67,
          "isolationGroup": 31,
          "continent": 3,
          "continentName": "MAZE ISLAND",
          "connections": [
               "NODE128",
               "NODE119",
               "NODE120",
               "NODE121",
               "NODE122"
          ],
          "type": "WATER"
     },
     "NODE119": {
          "locationKey": "MAZE_ISLAND_MAGIC",
          "x": 41,
          "y": 58,
          "isolationGroup": 31,
          "continent": 3,
          "continentName": "MAZE ISLAND",
          "connections": [
               "NODE122",
               "NODE123"
          ],
          "type": "ANY"
     },
     "NODE120": {
          "locationKey": "MAZE_ISLAND_FORCED_BATTLE_1",
          "x": 48,
          "y": 68,
          "isolationGroup": 31,
          "continent": 3,
          "continentName": "MAZE ISLAND",
          "suggestion": "passthrough!",
          "connections": [],
          "type": "ANY"
     },
     "NODE121": {
          "locationKey": "MAZE_ISLAND_FORCED_BATTLE_2",
          "x": 45,
          "y": 62,
          "isolationGroup": 31,
          "continent": 3,
          "continentName": "MAZE ISLAND",
          "suggestion": "passthrough!",
          "connections": [],
          "type": "ANY"
     },
     "NODE122": {
          "locationKey": "MAZE_ISLAND_FORCED_BATTLE_3",
          "x": 48,
          "y": 58,
          "isolationGroup": 31,
          "continent": 3,
          "continentName": "MAZE ISLAND",
          "suggestion": "passthrough!",
          "connections": [],
          "type": "ANY"
     },
     "NODE123": {
          "locationKey": "MAZE_ISLAND_FORCED_BATTLE_4",
          "x": 46,
          "y": 50,
          "isolationGroup": 31,
          "continent": 3,
          "continentName": "MAZE ISLAND",
          "suggestion": "passthrough!",
          "connections": [
               "NODE124",
               "NODE125",
               "NODE126",
               "NODE127"
          ],
          "type": "ANY"
     },
     "NODE124": {
          "locationKey": "MAZE_ISLAND_FORCED_BATTLE_5",
          "x": 48,
          "y": 46,
          "isolationGroup": 31,
          "continent": 3,
          "continentName": "MAZE ISLAND",
          "suggestion": "passthrough!",
          "connections": [],
          "type": "ANY"
     },
     "NODE125": {
          "locationKey": "MAZE_ISLAND_FORCED_BATTLE_6",
          "x": 50,
          "y": 42,
          "isolationGroup": 31,
          "continent": 3,
          "continentName": "MAZE ISLAND",
          "suggestion": "passthrough!",
          "connections": [],
          "type": "ANY"
     },
     "NODE126": {
          "locationKey": "MAZE_ISLAND_FORCED_BATTLE_7",
          "x": 51,
          "y": 49,
          "isolationGroup": 31,
          "continent": 3,
          "continentName": "MAZE ISLAND",
          "suggestion": "passthrough!",
          "connections": [],
          "type": "ANY"
     },
     "NODE127": {
          "locationKey": "P4",
          "x": 60,
          "y": 58,
          "isolationGroup": 31,
          "continent": 3,
          "continentName": "MAZE ISLAND",
          "connections": [],
          "type": "ANY"
     },
     "NODE128": {
          "locationKey": "MAZE_ISLAND_CHILD",
          "x": 57,
          "y": 60,
          "isolationGroup": 31,
          "continent": 3,
          "continentName": "MAZE ISLAND",
          "connections": [],
          "type": "ANY"
     },
     "NODE129": {
          "locationKey": "GP",
          "x": 4,
          "y": 73,
          "isolationGroup": 12,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE130": {
          "locationKey": "FIRE_TOWN",
          "x": 23,
          "y": 60,
          "isolationGroup": 7,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "ANY"
     },
     "NODE131": {
          "locationKey": "THUNDER_TOWN_SWAMP_LIFE",
          "x": 26,
          "y": 81,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "SWAMP"
     },
     "NODE132": {
          "locationKey": "THUNDER_TOWN_CAVE_500P_BAG",
          "x": 31,
          "y": 78,
          "isolationGroup": 9,
          "continent": 2,
          "continentName": "EAST HYRULE",
          "connections": [],
          "type": "CAVE"
     },
     "NODE133": {
          "locationKey": "ELEVATOR_CAVE_G_E_TL",
          "x": 9,
          "y": 47,
          "isolationGroup": 15,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE134": {
          "locationKey": "ELEVATOR_CAVE_H_W_TR",
          "x": 10,
          "y": 51,
          "isolationGroup": 18,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE135": {
          "locationKey": "CAVE_N_S",
          "x": 22,
          "y": 63,
          "isolationGroup": 26,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [],
          "type": "CAVE"
     },
     "NODE136": {
          "locationKey": "CAVE_N_N",
          "x": 24,
          "y": 60,
          "isolationGroup": 28,
          "continent": 1,
          "continentName": "DEATH MOUNTAIN",
          "connections": [
               "NODE117"
          ],
          "type": "CAVE"
     }
}
